import React from "react";

export const ViewImageContext = React.createContext({
   setImagePresents: null,
})